var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { matchPath } from "react-router-dom";
var SD_PREFIX = "sd";
var CLI_PREFIX = "cl";
var ENV_PREFIX = "en";
var bootstrapPath = "https://personicommedia.blob.core.windows.net/bootstrap";
var ENV_PATH = {
    development: "dev",
    localhost: "dev",
    qa: "qa",
    production: "prod",
};
export function getClientContext() {
    return __awaiter(this, void 0, void 0, function () {
        var theContext, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    theContext = {};
                    theContext.client = getClientFromUrl();
                    theContext.environment = getEnvironmentFromUrl();
                    theContext.subdomain = getSubdomainFromUrl();
                    theContext.isIframe = getIsInIframe();
                    _a = theContext;
                    return [4 /*yield*/, discoverBlobStoragePaths(theContext.client, theContext.environment)];
                case 1:
                    _a.blobPaths = _b.sent();
                    return [2 /*return*/, theContext];
            }
        });
    });
}
//===
// Gets a search parameter from the url by its name.  assumes search will be in the form: "?key=value&key2=value2"
export function getSearchParam(key) {
    var search = new URLSearchParams(window.location.search.slice(1).toLowerCase());
    return search.get(key);
}
//===
// Fetches a file from a specific url as JSON and returns a JSON object
//
export function fetchJsonFile(fileUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var result, json, err_1, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 8]);
                    return [4 /*yield*/, fetch(fileUrl, { method: "GET" })];
                case 1:
                    result = _a.sent();
                    if (!result.json) return [3 /*break*/, 3];
                    return [4 /*yield*/, result.json()];
                case 2:
                    json = _a.sent();
                    if (!result.ok) {
                        return [2 /*return*/, __assign({ isError: true, status: result.status, message: result.statusText }, json)];
                    }
                    return [2 /*return*/, json]; //all good, just return the result
                case 3:
                    if (result.ok === true) {
                        //Nothing to return, but all is good
                        return [2 /*return*/, result];
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 8];
                case 5:
                    err_1 = _a.sent();
                    errMsg = "Unhandled exception during fetch. Our technical team has been notified.";
                    if (!err_1.text) return [3 /*break*/, 7];
                    return [4 /*yield*/, err_1.text()];
                case 6:
                    errMsg = _a.sent();
                    _a.label = 7;
                case 7: return [2 /*return*/, {
                        isError: true,
                        message: errMsg
                    }];
                case 8: return [2 /*return*/];
            }
        });
    });
}
export function discoverBlobStoragePaths(client, environment) {
    return __awaiter(this, void 0, void 0, function () {
        var shortenv, hostName, theBlobStorageInfo, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shortenv = ENV_PATH[environment];
                    hostName = window.location.hostname.toLowerCase();
                    theBlobStorageInfo = {};
                    //For localhost environments, allow ServeStatic to take over.
                    if (hostName.indexOf("localhost") >= 0) {
                        theBlobStorageInfo.booostrapPath = "http://localhost:8100/personicom.com/bootstrap/localhost/" + client + ".json"; //servestatic
                    }
                    else {
                        theBlobStorageInfo.booostrapPath = bootstrapPath + "/" + shortenv + "/" + client + ".json";
                    }
                    console.log('Bootstrap: ' + theBlobStorageInfo.booostrapPath);
                    return [4 /*yield*/, fetchJsonFile(theBlobStorageInfo.booostrapPath)];
                case 1:
                    json = _a.sent();
                    if (json.isError) {
                        throw new Error(json.message);
                    }
                    if (hostName.indexOf("localhost") >= 0) {
                        theBlobStorageInfo.configPath = "http://localhost:8100/" + client; //servestatic
                    }
                    else {
                        theBlobStorageInfo.configPath = json.customizations_path;
                    }
                    theBlobStorageInfo.mediaPath = json.media_path; //this always points to blob storage silo's.
                    return [2 /*return*/, theBlobStorageInfo];
            }
        });
    });
}
//TODO: Apps should not be calling this directly. Fix Reporting and apps.
//Obsolete
//---
//Gets the url to the customizations blob container for the current brand.
export function getBaseUrl() {
    return __awaiter(this, void 0, void 0, function () {
        var client, environment, shortenv, hostName, customizations_path, bootstrap_path, json;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = getClientFromUrl();
                    environment = getEnvironmentFromUrl();
                    shortenv = ENV_PATH[environment];
                    hostName = window.location.hostname.toLowerCase();
                    //For dev environments, allow ServeStatic to take over.
                    if (hostName.indexOf("localhost") >= 0) {
                        bootstrap_path = "http://localhost:8100/personicom.com/bootstrap/localhost/" + client + ".json";
                    }
                    else {
                        bootstrap_path = bootstrapPath + "/" + shortenv + "/" + client + ".json";
                    }
                    console.log('Bootstrap: ' + bootstrap_path);
                    if (!(hostName.indexOf("localhost") >= 0)) return [3 /*break*/, 1];
                    customizations_path = "http://localhost:8100/" + client;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, fetchJsonFile(bootstrap_path)];
                case 2:
                    json = _a.sent();
                    if (json.isError) {
                        throw new Error(json.message);
                    }
                    customizations_path = json.customizations_path;
                    _a.label = 3;
                case 3:
                    console.log("client: " + client + ", hostname: " + hostName + ", customizations_path: " + customizations_path);
                    return [2 /*return*/, customizations_path];
            }
        });
    });
}
//===
// Gets the client, which is the product that is using reporting.  Current options are "universitymsgmedia" or "thevideobotmedia"
// url expected in the format of: reporting.[client].[com/net]?sd=[subdomain] or reporting.[client].localhost:XXXX?sd=[subdomain]
export function getClientFromUrl() {
    var _a;
    var client;
    // The client eventually maps to the 'rootdomain' in the BrandTemplate field.
    // Each client has one or more subdomains.
    // We should always allow the URL param ( CLI_PREFIX ) to override any inferred values from host.
    client = (_a = getSearchParam(CLI_PREFIX)) !== null && _a !== void 0 ? _a : "";
    if (client) {
        console.log("Client from URL:" + client);
        return client;
    }
    //Fall back to inferring the value from the host.
    var host = window.location.host.toLowerCase();
    var parts = host.split('.');
    client = parts.length > 2 ? parts[1] + "." + parts[2] : "";
    console.log("Client from Host:" + client);
    //TODO: make sure it ends with 'media' since the azure storage buckets all end with media?
    // if(client && !client.endsWith("media")) client = `${client}media`;
    return client;
}
//===
// Gets the subdomain for reporting, which currently is stored as a query parameter in the form: "sd=[subdomain]"
// if no subdomain is defined, will return empty string.
// url expected in the format of: reporting.[client].[com/net]?sd=[subdomain] or reporting.[client].localhost:XXXX?sd=[subdomain]
export function getSubdomainFromUrl() {
    var _a;
    var result = (_a = getSearchParam(SD_PREFIX)) !== null && _a !== void 0 ? _a : "";
    //Query params always win.
    if (result) {
        return result;
    }
    //Check if we're in UM land, need to handle things a bit differently, eg: 
    //  http://pittunscripted.universitymsg.com.localhost:5100/app/bulk-upload
    //  http://pittunscripted.universitymsg.com/app/bulk-upload
    //  http://qa.universitymsg.com/pittunscripted/app/bulk-upload
    //  http://dev.universitymsg.com/pittunscripted/app/bulk-upload
    var host = window.location.host.toLowerCase();
    if (host.indexOf("universitymsg")
        && !host.startsWith("videoreport.")
        && !host.startsWith("app.")
        && !host.startsWith("player.")
        && !host.startsWith("demo.")
        && !host.startsWith("reporting.")) {
        return getSchoolFromUrl();
    }
    //Check for a match with the player path to see if the subdomain is there.
    if (!result) {
        var matchResult = matchPath(window.location.pathname, {
            path: "/:subdomain",
            exact: false,
            strict: true,
        });
        if (matchResult) {
            return matchResult.params["subdomain"];
        }
    }
    return result;
}
export function getSchoolFromUrl() {
    var school = "default";
    //Need to support direct access to iFrame version in local, qa and dev
    var pathParts = window.location.pathname.split('/');
    if (pathParts.length === 3 && ["iframe", "player"].indexOf(pathParts[2].toLowerCase()) >= 0) {
        school = pathParts[1];
    }
    else {
        var host = window.location.host.toLowerCase();
        //For dev/stage we're going to use the first path to specify subdomain. https://dev.universitymsg.com/nextstopnjit/
        if (host.indexOf("dev.") >= 0 || host.indexOf("qa.") >= 0) {
            school = window.location.pathname.split('/')[1];
        }
        else {
            var partCount = host.indexOf("localhost") >= 0 ? 1 : 2; //localhost doesn't have the .com, so expect different parts
            var parts = host.split('.');
            school = parts.length > partCount ? parts[0] : "default";
        }
    }
    return school;
}
//===
// Gets the environment for reporting.  This may be based on the hostname, or it might be in the querystring
// depending on the environment and url.
export function getEnvironmentFromUrl() {
    var env = getSearchParam(ENV_PREFIX);
    if (!env) {
        var hostName = window.location.hostname.toLowerCase();
        if (hostName.indexOf("qa.") >= 0) {
            env = "qa";
        }
        else if (hostName.indexOf("dev.") >= 0) {
            env = "development"; //Allow for a query string override in development
        }
        else if (hostName.indexOf("localhost") >= 0) {
            env = "development"; //Allow for a query string override in development
        }
        else {
            env = "production";
        }
    }
    return env;
}
//===
// Gets whether or not the app is running inside an iFrame
export function getIsInIframe() {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
}
//===
// A deep, immutable merge function, from: https://gist.github.com/ScriptedAlchemy/25be43bfb45baaf047a7991de4b64127
export function mergeDeep() {
    var objects = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        objects[_i] = arguments[_i];
    }
    var isObject = function (obj) { return obj && typeof obj === 'object'; };
    return objects.reduce(function (prev, obj) {
        Object.keys(obj).forEach(function (key) {
            var pVal = prev[key];
            var oVal = obj[key];
            if (Array.isArray(pVal) && Array.isArray(oVal)) {
                prev[key] = pVal.concat.apply(pVal, oVal);
            }
            else if (isObject(pVal) && isObject(oVal)) {
                prev[key] = mergeDeep(pVal, oVal);
            }
            else {
                prev[key] = oVal;
            }
        });
        return prev;
    }, {});
}
//===
// Checks to see if the two objects are the same reference, and therefore the object was mutated. Adds a Console.Warning if this is the case.
export function checkForMutation(obj1, obj2, objName) {
    if (obj1 === obj2) {
        console.warn("!! mutation detected: " + objName + " is mutated.", __assign({}, obj1), __assign({}, obj2));
    }
}
